module.exports = __webpack_public_path__ + "static/13-937b4757b97c682006841b2660f47bfc.jpg";